import { CoverType } from 'src/common/utils/api/urls';
import { INTERNATIONAL_DESKTOP_ASSETS } from 'src/common/utils/config';
import {
  TravelInsurancePages,
  TravelInsuranceViewEvents,
  TravelPassPages,
  VasPages,
} from 'src/common/utils/segment/types';

export const TravelActionType = {
  COLLECT_TRAVEL_DETAILS: 'collect_travel_details',
  SHOW_STORIES: 'show_stories',
  COLLECT_MEDICAL_COVER: 'collect_medical_cover',
  COLLECT_PLANS: 'collect_plans',
  COLLECT_ADDONS: 'collect_addons',
  COLLECT_TRAVELLER_DETAILS: 'collect_traveller_details',
  CHECKOUT: 'checkout',
  INITIATE_PAYMENT: 'initiate_payment',
  CONFIRM_PAYMENT: 'confirm_payment',
  LOAD_POLICY: 'load_policy',
  INITIATE_KYC: 'initiate_kyc',
  TRIP_INFO: 'tripInfo',
  POLICY_ACTIVATED: 'policy_activated',
  COMPLIANCE_PENDING: 'compliance_pending',
};

export const COUPON_CARD_ACTIONS = {
  APPLY: 'apply coupon',
  REMOVE: 'remove coupon',
  SEE_ALL_COUPONS: 'see all coupons',
  SEE_DETAILS: 'see coupon details',
};

export const APPLY_COUPON_RESPONSE_CODE = {
  SUCCESS: 'SUCCESS',
  INVALID: 'INVALID_CODE',
};

export const COUPON_TYPE = 'COUPON';

export const COTRAVELLER_COUPON_CODE = 'COTRAVELLER10';

export const APPLY_COUPON_MESSAGES = {
  SUCCESS: 'Coupon applied successfully!',
  INVALID: 'Only one coupon can be applied!',
  DEFAULT: 'Oops! This coupon is not valid',
  ERROR: 'Oops! Something went wrong. Please try again.',
};

export const UnbundledDesktopStages = [
  'Trip info',
  'Build plan',
  'Personal details',
  'Review & Pay',
];

export const BundledDesktopStages = [
  'Trip info',
  'Choose plan',
  'Personal details',
  'Review & Pay',
];

export const Stages = ['Trip info', 'Plan info', 'Details', 'Checkout'];

export const PackageType = {
  UNBUNDLED: 'unbundled',
  BUNDLED: 'bundled',
};

export const CoverTypeList = [
  CoverType.MEDICAL,
  CoverType.TRIP,
  CoverType.BAGGAGE,
];
export const PageType = {
  unbundled: 'unbundled_only_cohort',
  bundled: 'bundled_only_cohort',
  default: 'buy',
};

export const Category = {
  SENIOR_CITIZEN: 'senior_citizen',
  ADULT: 'adult',
  CHILD: 'child',
  CHILDREN: 'children',
};

export const CurrencyType = {
  INR: '₹',
  USD: '$',
};

export const modalTypes = {
  benefits: {
    label: 'Medical cover benefits',
    type: 'benefits',
  },
  claimAmount: {
    label: 'Hospitalisation bills coverage',
    type: 'claim amount',
  },
  medicalUsage: {
    label: 'How to use this cover?',
    type: 'medical usage',
  },
};

export const LongTermConditions = [
  'Hypertension',
  'Diabetes mellitus',
  'Chronic illness',
  'Asthma',
  'Thyroid',
  'High bood pressure',
  'Epilepsy',
  'Lupus',
];

export const PASSPORT_ERRORS = {
  DUPLICATE:
    'This passport number is linked to another traveller in this policy',
  EMPTY: 'We need your passport number',
  INVALID: 'Please enter a valid passport number',
};

export const NAME_ERRORS = {
  INVALID_FORMAT: 'Special characters like @, #, $ are not allowed',
};

export const REQUIRED_FIELD_ERROR = 'This is a required field';

export const PHONE_ERROR = 'Please enter a valid mobile number';

export const MISSING_FIELDS_ERROR = 'Please enter the required fields';

export const BUNDLED_PLAN_CATEGORIES = {
  COMFORT: 'comfort',
  SMART: 'smart',
};

export const StateToPageMapper = {
  package_selection: TravelInsurancePages.INT_TRAVEL_FORK_SCREEN,
  medical_cover_selection:
    TravelInsurancePages.INT_TRAVEL_UNBUNDLED_MEDICAL_COVER,
  trip_cover_selection: TravelInsurancePages.INT_TRAVEL_UNBUNDLED_TRIP_COVER,
  baggage_cover_selection:
    TravelInsurancePages.INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER,
  bundled_addon_selection: TravelInsurancePages.INT_TRAVEL_BUNDLED_ADDON_SCREEN,
  bundled_plan_selection:
    TravelInsurancePages.INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN,
  journey_summary: TravelInsurancePages.INT_TRAVEL_REVIEW_SCREEN,
  trip_details_collection: TravelInsurancePages.INT_TRAVEL_TRIP_INFO_SCREEN,
  traveller_details_updation:
    TravelInsurancePages.INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN,
  compliance_pending:
    TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN,
  policy_activated: TravelInsurancePages.INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN,
  policy_compliance_initiated:
    TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS,
  payment_pending: TravelInsurancePages.INT_TRAVEL_PAYMENT_PENDING_SCREEN,
  null: TravelInsurancePages.HOME,
  vas: VasPages.TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE,
  seo: TravelInsurancePages.SEO,
};

export const TravelPassStateToPageMapper = {
  landing_page: TravelPassPages.FLIGHT_PASS_LANDING_PAGE,
  payment_initiated: TravelPassPages.FLIGHT_PASS_PAYMENT_INITIATED_PAGE,
  payment_processing: TravelPassPages.FLIGHT_PASS_PAYMENT_PROCESSING_PAGE,
  payment_success: TravelPassPages.FLIGHT_PASS_PAYMENT_SUCCESS_PAGE,
  payment_failed: TravelPassPages.FLIGHT_PASS_PAYMENT_FAILED_PAGE,
  policy_init: TravelPassPages.FLIGHT_PASS_POLICY_INIT_PAGE,
  policy_success: TravelPassPages.FLIGHT_PASS_POLICY_SUCCESS_PAGE,
};

export const StateToViewEventsMapper = {
  medical_cover_selection:
    TravelInsuranceViewEvents.VIEW_PAGE_INT_MEDICAL_COVER,
  trip_cover_selection: TravelInsuranceViewEvents.VIEW_PAGE_INT_TRIP_COVER,
  baggage_cover_selection:
    TravelInsuranceViewEvents.VIEW_PAGE_INT_BAGGAGE_COVER,
  policy_compliance_initiated:
    TravelInsuranceViewEvents.VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS,
};

export const StateToPersuasionMapper = {
  medical_cover_selection:
    TravelInsurancePages.INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL,
  trip_cover_selection:
    TravelInsurancePages.INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL,
  baggage_cover_selection:
    TravelInsurancePages.INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL,
};

export const partnerWidgetTravellers = [
  {
    index: 0,
    count: 0,
    category: 'adult',
    title: 'Adult',
    sub_title: '18-60 years',
  },
  {
    index: 1,
    count: 0,
    category: 'child',
    title: 'Child',
    sub_title: 'below 18 years',
  },
  {
    index: 2,
    count: 0,
    category: 'senior_citizen',
    title: 'Senior citizen',
    sub_title: '60-70 years',
    note: {
      icon_url: 'https://travel.ackoassets.com/images/info.svg',
      text: 'We do not cover travellers aged 70 and above',
    },
  },
];

export const internationalInsuranceUsps = [
  {
    image_url: INTERNATIONAL_DESKTOP_ASSETS.PASSPORT_ICON,
    description: 'Visa compliant policies',
  },
  {
    image_url: INTERNATIONAL_DESKTOP_ASSETS.CUSTOMER_SUPPORT,
    description: '9 out 10 claims settled within 24 hours',
  },
  {
    image_url: INTERNATIONAL_DESKTOP_ASSETS.MONEY_ICON,
    description: 'Prices starting at Rs. 49/day*',
  },
  {
    image_url: INTERNATIONAL_DESKTOP_ASSETS.NOTES_ICON,
    description: 'Cancel or edit your policy on our app any time',
  },
];

export const beemaConfig = {
  URL: 'https://acko-cms.ackoassets.com/bimagyaan_quiz_ac0e2af536.png',
  QUIZ_URL: 'https://www.mygov.in/',
};
